import { render, staticRenderFns } from "./form.vue?vue&type=template&id=3b144e58&scoped=true"
import script from "./form.ts?vue&type=script&lang=ts&external"
export * from "./form.ts?vue&type=script&lang=ts&external"
import style0 from "./form.vue?vue&type=style&index=0&id=3b144e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b144e58",
  null
  
)

export default component.exports